import { FC, useEffect, useState } from "react";
import {
  Banner,
  ButtonSmallWO,
  PageContainer,
  PageWrapper,
  Paragraph,
  SubHeading,
} from "../shared.styled";
import logo from "../../assets/images/logo.svg";
import { Device } from "../../api/models";
import { getJWT, get } from "../../api/api";
import { useNavigate, useParams } from "react-router-dom";
import { LeftOutlined } from "@ant-design/icons";
import { OptionSelection } from "./setup.styled";

const Saved: FC = (): JSX.Element => {
	const {deviceId} = useParams();
  const [device, setDevice] = useState<Device>();
  const navigate = useNavigate();

  useEffect(() => {
    const getDevice = async () => {
      const JWT = getJWT();
      if (JWT && JWT.deviceId) {
        const device = await get(`/device/${deviceId ?? JWT.deviceId}`);
        if (device.data) {
          setDevice(device.data);
        }
      } else {
        setTimeout(getDevice, 500);
      }
    };
    getDevice();
  }, []);

  return (
    <PageWrapper>
      <PageContainer style={{ textAlign: "center" }}>
        <Banner>
          <img src={logo} alt="logo" width="260" />
        </Banner>
        <SubHeading>Saved!</SubHeading>
        <Paragraph style={{ padding: 0 }}>
          Ok, we've got these sources saved and ready for your device:
        </Paragraph>
        {device?.dataSources && (
          <Paragraph style={{ marginTop: 20 }}>
            {device.dataSources.map((option) => (
              <OptionSelection key={option.sourceId}>
                {option.title}
              </OptionSelection>
            ))}
          </Paragraph>
        )}
        <Paragraph style={{ marginTop: 10 }}>
          It might take a few minutes for your device to update...
        </Paragraph>
        <ButtonSmallWO
          style={{ marginTop: "20px" }}
          onClick={() => {
            navigate("/setup");
          }}
        >
          <LeftOutlined /> Back To Setup
        </ButtonSmallWO>
      </PageContainer>
    </PageWrapper>
  );
};

export default Saved;
